/**
 * Dispara feedback háptico (vibração) quando disponível.
 * Útil em botões e links no mobile para resposta tátil ao toque.
 * @param duration Duração em ms (padrão 15)
 */
export function vibrateTactile(duration = 15): void {
  if (
    typeof navigator !== "undefined" &&
    typeof navigator.vibrate === "function"
  ) {
    try {
      navigator.vibrate(duration);
    } catch {
      // API não suportada ou bloqueada (ex.: contexto não seguro)
    }
  }
}
